export function loadLocale(locale: string): Record<string, any> | null {
    try {
        const localeData = require(`./${locale}.json`);
        return localeData;
    } catch (error) {
        console.warn(`Locale file for '${locale}' not found or invalid.`);
        return null;
    }
}
